import React, { useContext, useRef } from "react";
import { useState, useEffect } from "react";
import "./My_Table.css";
import Select from "react-select";
import { Table, Button, Form } from "react-bootstrap";
import { Context } from "../../../../utils/context";
import {
  deleteData,
  editStatusData,
  getData,
  getDownloadDataExcel,
  postData,
} from "../../../../utils/api";
import { Link } from "react-router-dom";
import {
  ApprovalStatus,
  IDS,
  RoleId,
  Select2Data,
  VendorType,
} from "../../../../utils/common";
import LinkDesignsModel from "../LinkDesignsModel";
import { DeletButton } from "../../../common/Button";
import ModalDelete from "../../../common/ModelDelete";
import search1 from "../../../assets/icons/search.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import toast from "react-hot-toast";
import EditplatformchargeModal from "../PlatformCharge";
import ImagePreviewDialog from "../../../common/ImagePreview/ImagePreview";
function My_Table({
  data,
  getDataAll,
  OrderByOptions,
  user,
  reset,
  setonPageChange,
  store_id,
  setStoreId,
  paramid,
  setChangeStatus,
  // sortOrder,
  // setSortOrder,
  resultsPerPageOptions,
  perPage,
  setperPage,
  setReset,
  hideFilter,
  setHideFilter,
  option,
  setStoreCategory,
  childCategories,
  subCategories,
  categories,
  setSearchCategory,
  setSearchSubCategory,
  setSearchChildCategory,
  searchChildCategory,
  searchSubCategory,
  searchCategory,
  getAllSubCategories,
  getAllChildCategories,
  setSearch,
  search,
  searchDateTo,
  searchDateFrom,
  setSearchDateTo,
  setSearchDateFrom,
  setSubCategories,
  setChildCategories,
  HandleDownload,
  HandleDownloadDesignOrder,
  handleViewVendorDesigns,
  vendorSearch,
  setVendorSearch,
  vendors,
}) {
  const { IMG_URL, ErrorNotify, isAllow } = useContext(Context);

  const customSelectStyles = {
    control: (base) => ({
      ...base,
      borderRadius: "20px",
      borderColor: "#ddd",
      boxShadow: "none",
      fontSize: "15px",
      "&:hover": {
        borderColor: "#aaa",
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "#000",
    }),
    menu: (base) => ({
      ...base,
      borderRadius: "10px",
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
      color: "#000",
      fontSize: "15px",
      "&:hover": {
        backgroundColor: "#eee",
      },
    }),
  };

  const [showModel, setShowModel] = useState(0);

  const calculateTimeAgo = (date) => {
    const createdAt = new Date(date);
    const now = new Date();
    const diffInMilliseconds = now - createdAt;

    const diffInMinutes = Math.floor(diffInMilliseconds / 60000);
    const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));

    if (diffInDays >= 1) {
      return `${diffInDays} Day${diffInDays > 1 ? "s" : ""} Ago`;
    } else if (diffInHours >= 1) {
      return `${diffInHours} Hour${diffInHours > 1 ? "s" : ""} Ago`;
    } else {
      return `${diffInMinutes} Min Ago`;
    }
  };

  const formatTimeInIST = (date) => {
    const createdAt = new Date(date);
    const options = { hour: "2-digit", minute: "2-digit", hour12: true };
    const istTime = createdAt.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      ...options,
    });
    // setFormattedTime(`${istTime} IST`);
    return istTime;
  };

  const ChangeSuggestedDesignStatus = async (id, option) => {
    try {
      // Send the POST request to update the store's status
      await postData(`/admin/vendor/design/${id}`, {
        approval_status_id: option,
      });

      // Refresh the data after updating the store's status
      await getDataAll();
    } catch (error) {
      console.error("Error updating store status:", error);
    }
  };

  // Delete module
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedDesignId, setSelectedDesignId] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  const handleDeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(
        `/admin/vendor/design/${recordToDeleteId}`,
      );
      if (response?.success) {
        getDataAll();
      }

      ErrorNotify(recordToDeleteName);

      setRecordToDeleteId(null);
      setRecordToDeleteName(null);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
    setRecordToDeleteName(null);
  };

  const ChangeStatus = async (id) => {
    const response = await editStatusData(`/admin/designs/${id}`);
    setChangeStatus(response);
  };

  const ChangeTopPick = async (id) => {
    const response = await editStatusData(`/admin/designs/top-pick/${id}`);
    setChangeStatus(response);
  };

  const ChangeSeasonable = async (id) => {
    const response = await editStatusData(
      `/admin/designs/seasonable-status/${id}`,
    );
    setChangeStatus(response);
  };
  const ChangeBestSeller = async (id) => {
    const response = await editStatusData(
      `/admin/designs/best-seller-status/${id}`,
    );
    setChangeStatus(response);
  };

  const [sortBy, setSortBy] = useState("orders"); // "orders" or "price"
  const [sortOrder, setSortOrder] = useState("asc");
  const sortedData = [...(data?.data?.data || [])].sort((a, b) => {
    const totalA = a?.Design_Order_Details?.reduce(
      (sum, detail) => sum + parseFloat(detail?.total_amount || 0),
      0,
    );

    const totalB = b?.Design_Order_Details?.reduce(
      (sum, detail) => sum + parseFloat(detail?.total_amount || 0),
      0,
    );

    if (sortBy === "price") {
      return sortOrder === "asc" ? totalA - totalB : totalB - totalA;
    } else {
      // fallback: sort by order count
      const countA = a?.Design_Order_Details?.length || 0;
      const countB = b?.Design_Order_Details?.length || 0;
      return sortOrder === "asc" ? countA - countB : countB - countA;
    }
  });

  const handleApproveWithCharge = async (platformCharge) => {
    try {
      const chargeData = new FormData();
      chargeData.append("platform_charges", platformCharge);

      const chargeResponse = await postData(
        `/admin/vendor/design/edit/${selectedDesignId}`, // Changed endpoint
        chargeData,
      );

      if (!chargeResponse?.success) {
        toast.error("Failed to update platform charge");
        return;
      }
      const statusResponse = await postData(
        `/admin/vendor/design/${selectedDesignId}`,
        {
          approval_status_id: ApprovalStatus.Approved,
        },
      );

      if (statusResponse?.success) {
        toast.success("Design approved successfully");

        await getDataAll();
      } else {
        toast.error("Failed to update approval status");
      }
    } catch (error) {
      console.error("Error in approval process:", error);
      toast.error("Something went wrong");
    } finally {
      setShowEditModal(false);
      setSelectedDesignId(null);
    }
  };

  const dialogRef = useRef();
  const [selectedImage, setSelectedImage] = useState("");

  const openImage = (image) => {
    setSelectedImage(image);
    dialogRef.current?.showModal();
  };

  return (
    <section className="pending-table_holder">
      {/* Quick Filters Section */}
      <div className="quick-filters mt-3">
        <span className="quick-filters__label">
          <b>Quick Filters:</b>
        </span>
        <div className="quick-filters__tabs mt-3">
          <div className="row align-items-end">
            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <Form.Label>Design Name</Form.Label>
              <Form.Control
                placeholder="Enter Design Name"
                type="text"
                className="form-control"
                id=""
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    setonPageChange(1);
                    getDataAll();
                  }
                }}
              />
            </div>
            {!paramid && (
              <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
                <Form.Label>Select Vendor</Form.Label>

                <Select
                  isSearchable
                  options={vendors}
                  value={vendorSearch}
                  placeholder="Select Vendor"
                  onChange={(e) => {
                    setVendorSearch(e);
                    setonPageChange(1);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      setonPageChange(1);
                      getDataAll();
                    }
                  }}
                  classNamePrefix="searchVendor"
                />
              </div>
            )}

            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <Form.Label>Select Category </Form.Label>
              <Select
                isSearchable
                options={categories}
                value={searchCategory}
                placeholder="Select Category"
                onChange={(e) => {
                  setSearchCategory(e);
                  getAllSubCategories(e.value);
                  setChildCategories("");
                  setSubCategories("");
                  setSearchSubCategory("");
                  setSearchChildCategory("");
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    setonPageChange(1);
                    getDataAll();
                  }
                }}
                classNamePrefix="searchDesign"
              />
            </div>

            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <div className="num me-2">
                <label className="form-label">From Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="from"
                  value={searchDateFrom}
                  onChange={(e) => {
                    const value = e.target.value;
                    const year = value.split("-")[0];

                    // Check if year has 4 digits
                    if (year.length === 4 || value === "") {
                      setSearchDateFrom(value);
                      setonPageChange(1);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      setonPageChange(1);
                      getDataAll();
                    }
                  }}
                />
              </div>
            </div>

            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2">
              <div className="num me-2">
                <label className="form-label">To Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="to"
                  value={searchDateTo}
                  onChange={(e) => {
                    setSearchDateTo(e.target.value);
                    setonPageChange(1);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      setonPageChange(1);
                      getDataAll();
                    }
                  }}
                />
              </div>
            </div>

            <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2 d-flex gap-3 align-items-end">
              <div className="Search me-2">
                <Button
                  type="button"
                  onClick={getDataAll}
                  className="btn btn-search"
                >
                  <img src={search1} className="search" alt="" />
                </Button>
              </div>
              <div className="Search-1">
                <button
                  type="button"
                  onClick={() => {
                    setSearch("");
                    setVendorSearch("");
                    setSearchDateFrom("");
                    setSearchDateTo("");
                    setSearchCategory("");
                    setSearchChildCategory("");
                    setSearchSubCategory("");
                    setReset(!reset);
                  }}
                  className="btn btn-reset"
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Table Section */}
      <div className="pending-table ">
        <Table striped bordered hover className="order-table" responsive>
          <thead>
            <tr>
              <th>Creation Date</th>
              <th>Design details</th>
              <th>Vendor Name</th>
              {/* <th>Store details</th> */}
              <th>Image</th>
              <th>Patent Certificate</th>
              <th>Categories</th>
              {/* <th>Total Order</th> */}
              <th>Description</th>

              {/* {user && user?.role_id === RoleId.Vendor && */}
              <th>Status</th>
              {/* } */}
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {sortedData?.map((item, index) => (
              <tr key={index}>
                <td className="order-date">
                  <div className="order-id">
                    {calculateTimeAgo(item?.createdAt)}
                  </div>
                  <div className="order-info">
                    <span>
                      {new Date(item?.createdAt).toISOString().split("T")[0]}
                    </span>
                  </div>
                  <div className="order-info">
                    <span>{formatTimeInIST(item?.createdAt)} IST</span>
                  </div>
                </td>

                {/* Owner Details */}
                <td className="order-details">
                  <div className="order-id text-highlight">
                    <b>{item?.Design?.item_code}</b>
                  </div>
                  <div className="order-info">
                    <span className="text-highlight">{item?.Design?.name}</span>
                  </div>
                  {/* <div className="order-info">
                    <span>{item?.price} / {item?.Unit?.name}</span>
                  </div> */}
                </td>
                <td>
                  <div className="order-info">
                    <span className="text-highlight">{item?.User?.name}</span>
                  </div>
                </td>

                <td>
                  <img
                    src={IMG_URL + item?.Design?.image}
                    alt="Design"
                    className="product-image"
                    onClick={() => openImage(IMG_URL + item?.Design?.image)}
                  />
                </td>

                <td>
                  {item?.Design?.petent_certificate ? (
                    <img
                      src={IMG_URL + item?.Design?.petent_certificate}
                      alt="Design"
                      className="product-image"
                      onClick={() =>
                        openImage(IMG_URL + item?.Design?.petent_certificate)
                      }
                    />
                  ) : (
                    <>No Image Upload</>
                  )}
                </td>

                <td className="order-details">
                  {/* <div className="order-info">
                    <span className="text-highlight">{item?.Store_Detail?.store_name}</span>
                  </div> */}
                  <div className="order-info">
                    <b>Category :</b>
                    <span>{item?.Design?.Category?.name}</span>
                  </div>
                  <div className="order-info">
                    <b>Sub Category :</b>
                    <span>{item?.Design?.Sub_Category?.name} </span>
                  </div>

                  <div className="order-info">
                    <b>Design Type:</b>
                    <span>{item?.User?.vendor_type_id === VendorType.NormalVendor ? " Normal Design" :"Fashion Design"} </span>
                  </div>
                </td>

                <td>
                  <div className="order-info">
                    <span>{item?.Design?.description} </span>
                    {/* {item?.tax_percentage && (
                      <>
                        <div className="order-id">Tax</div>
                        <span>{item?.tax_percentage} % </span>
                      </>
                    )} */}
                  </div>
                </td>

                {/* <td>
                  {item?.Often_Ordered_Withs?.map((item) => (
                    <div key={item?.id} className="order-info">
                      <span className="text-highlight"> {item?.linked_product?.name}</span>
                    </div>
                  ))}

                  
                  <Button
                    className="action-btn my-1"
                    onClick={() =>
                      setShowModel(item?.id)
                    }
                    style={{ marginTop: "auto" }}
                  >
                    Edit
                  </Button>
                

                </td> */}

                {/* {user && user?.role_id === RoleId.Vendor && */}

                {/* <td>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        checked={item?.status}
                        onChange={() => {
                          ChangeStatus(item?.id);
                        }}
                        id={`flexSwitchCheckDefault${item?.id}`}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`flexSwitchCheckDefault${item?.id}`}
                      >
                        {item?.status ? "Active" : "Inactive"}
                      </label>
                    </div>
                  </td> */}

                <td>
                  {isAllow.includes(IDS.Vendor_Design.Edit) &&
                    item?.approval_status_id === ApprovalStatus.Pending && (
                      <div className="d-flex gap-2">
                        {/* <Button
                        className="btn-success"
                        size="sm"
                        onClick={() => {
                          ChangeSuggestedDesignStatus(
                            item?.id,
                            ApprovalStatus.Approved,
                          );
                        }}
                      >
                        Approve
                      </Button> */}

                        <Button
                          className="btn-success"
                          size="sm"
                          onClick={() => {
                            setShowEditModal(true);
                            setSelectedDesignId(item?.id);
                          }}
                        >
                          Approve
                        </Button>

                        <Button
                          className="btn-danger"
                          size="sm"
                          onClick={() => {
                            ChangeSuggestedDesignStatus(
                              item?.id,
                              ApprovalStatus.Rejected,
                            );
                          }}
                        >
                          Reject
                        </Button>
                      </div>
                    )}

                  {item?.approval_status_id === ApprovalStatus.Approved && (
                    <span className="text-success">Approved</span>
                  )}

                  {item?.approval_status_id === ApprovalStatus.Rejected && (
                    <span className="text-danger">Rejected</span>
                  )}
                </td>

                <td>
                  {/* {user && user?.role_id === RoleId.Vendor && */}
                  <div className="my-1">
                    {isAllow.includes(IDS.Vendor_Design.List) ? (
                      <>
                        {" "}
                        <Button
                          className="action-btn view-btn mb-1"
                          onClick={() => handleViewVendorDesigns(item?.id)}
                        >
                          View Price
                        </Button>
                        <Link to={`/vendor-design/edit/${item?.Design?.id}`}>
                          <Button className="action-btn active">Edit</Button>
                        </Link>
                      </>
                    ) : (
                      <></>
                    )}
                    {/* <Link to={`/suggested-designs/edit/${item?.id}`}>
                      <Button className="action-btn active">Edit</Button>
                    </Link> */}
                    <div className="my-1">
                      {isAllow.includes(IDS.Vendor_Design.Delete) ? (
                        <Button
                          className="action-btn btn-danger"
                          onClick={() => showDeleteRecord(item?.id, item?.name)}
                        >
                          Delete
                        </Button>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                  {/* } */}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <LinkDesignsModel
        user={user}
        show={showModel}
        handleClose={() => {
          setShowModel(0);
          getDataAll();
        }}
      />
      <ModalDelete
        show={showDeleteModal}
        handleDeleteRecord={handleDeleteRecord}
        handleDeleteCancel={handleDeleteCancel}
      />

      <EditplatformchargeModal
        show={showEditModal}
        id={selectedDesignId}
        handleClose={() => {
          setShowEditModal(false);
          setSelectedDesignId(null);
        }}
        onApprove={handleApproveWithCharge}
      />

      <ImagePreviewDialog ref={dialogRef} image={selectedImage} />
    </section>
  );
}

export default My_Table;
